import React, { FC } from 'react';
import RoutableNotEditableLink from '../../../routableNotEditableLink';
import { TProductCardSolutions } from '../../types/seriesListing.types';

export type TProductSolutionBadgeProps = {
  solutions?: TProductCardSolutions[];
  linkUrl: string;
};

const SolutionBadge: FC<TProductSolutionBadgeProps> = (props) => {
  const { solutions, linkUrl } = props;

  return (
    <div className="product-card__wrapper--card-label-wrapper">
      {solutions?.map((item) => {
        return (
          <div className="product-card__wrapper--card-label">
            <RoutableNotEditableLink href={linkUrl}>{item?.title}</RoutableNotEditableLink>
          </div>
        );
      })}
    </div>
  );
};

export default React.memo(SolutionBadge);
